import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/ownerLogin',
      name: 'ownerLogin',
      component: resolve => require(['@/page/new/ownerLogin'], resolve)
    },
    {
      path: '/',
      name: 'commonScamsPage',
      component: resolve => require(['@/page/commonScamsPage'], resolve)
    },
    {
      path: '/wite',
      name: 'wite',
      component: resolve => require(['@/page/new/wite'], resolve)
    },
    {
      path: '/linkM',
      name: 'linkM',
      component: resolve => require(['@/page/new/linkMy'], resolve)
    },
    // 第二版界面
    {
      path: '/apm',
      name: 'login',
      component: resolve => require(['@/page/new/Login'], resolve)
    },
    {
      path: '/index',
      name: 'index',
      redirect: '/commonQuestion',
      component: resolve => require(['@/page/new/index'], resolve),
      children: [
        { // 共通问题采集
          path: '/commonQuestion/:num?',
          name: 'commonQuestion',
          component: resolve => require(['@/page/new/question/commonQuestion'], resolve)
        },{ // 嫌疑人问题采集
          path: '/liarInfoQuestion/:isBack?',
          name: 'liarInfoQuestion',
          component: resolve => require(['@/page/new/question/liarInfoQuestion'], resolve)
        },{ // 微信、QQ取证
          path: '/chatForensics',
          name: 'chatForensics',
          component: resolve => require(['@/page/new/question/LQuestion/chatForensics'], resolve)
        },{ // electronicEvidence
          path: '/electronicEvidence',
          name: 'electronicEvidence',
          component: resolve => require(['@/page/new/question/LQuestion/electronicEvidence'], resolve)
        },{ // 被骗经过
          path: '/beingCheated',
          name: 'beingCheated',
          component: resolve => require(['@/page/new/question/ConQuestion/beingCheated'], resolve)
        },{ // 确认
          path: '/checkInfo',
          name: 'checkInfo',
          component: resolve => require(['@/page/new/question/ConQuestion/checkInfo'], resolve)
        },{ // 笔录
          path: '/recordMange',
          name: 'recordMange',
          component: resolve => require(['@/page/new/question/ConQuestion/recordMange'], resolve)
        },{ // 上传 下载
          path: '/upDownFile',
          name: 'upDownFile',
          component: resolve => require(['@/page/new/question/ConQuestion/upDownFile'], resolve)
        },{ // 取证报告
          path: '/evidenceRecord',
          name: 'evidenceRecord',
          component: resolve => require(['@/page/new/question/ConQuestion/evidenceRecord'], resolve)
        },
      ]
    },
    // 第一版界面
    /*{
      path: '/apm',
      name: 'login',
      component: resolve => require(['@/page/login'], resolve)
    },
    {
      path: '/index',
      name: 'index',
      redirect: '/commonQuestion',
      component: resolve => require(['@/page/index'], resolve),
      children: [
        { // 共通问题采集
          path: '/commonQuestion',
          name: 'commonQuestion',
          component: resolve => require(['@/page/question/commonQuestion'], resolve)
        },{ // 嫌疑人问题采集
          path: '/liarInfoQuestion',
          name: 'liarInfoQuestion',
          component: resolve => require(['@/page/question/liarInfoQuestion'], resolve)
        },{ // 本人问题采集
          path: '/myselfQuestion',
          name: 'myselfQuestion',
          component: resolve => require(['@/page/question/myselfQuestion'], resolve)
        },{ // 问题汇总
          path: '/infoConf',
          name: 'infoConf',
          component: resolve => require(['@/page/question/ConQuestion/infoConf'], resolve)
        },{ // 被骗经过
          path: '/beingCheated/:pid?/:newid?',
          name: 'beingCheated',
          component: resolve => require(['@/page/question/ConQuestion/beingCheated'], resolve)
        },{ // 核对
          path: '/checkInfo/:pid?/:newid?',
          name: 'checkInfo',
          component: resolve => require(['@/page/question/ConQuestion/checkInfo'], resolve)
        },{ // 笔录
          path: '/recordMange/:pid?/:newid?',
          name: 'recordMange',
          component: resolve => require(['@/page/question/ConQuestion/recordMange'], resolve)
        },
        { // 修改问题采集
          path: '/editQuestion',
          name: 'editQuestion',
          component: resolve => require(['@/page/question/editQuestion'], resolve)
        },{
          path: '/appExtractHasOrNot', // app提取询问
          name: 'appExtractHasOrNot',
          component: resolve => require(['@/page/question/AppObtain/appExtractHasOrNot'], resolve)
        },{
          path: '/appExtract', // app提取
          name: 'appExtract',
          component: resolve => require(['@/page/question/AppObtain/appExtract'], resolve)
        },
        { // 动态抓包前是否页面
          path: '/yesOrNo',
          name: 'yesOrNo',
          component: resolve => require(['@/page/question/AppObtain/yesOrNo'], resolve)
        },
        { // 动态抓包
          path: '/grabBag',
          name: 'grabBag',
          component: resolve => require(['@/page/question/AppObtain/grabBag'], resolve)
        }
      ]
    },*/
    {
      path: '/magageIndex',
      name: 'magageIndex',
      redirect: '/evidenceSearch',
      component: resolve => require(['@/page/magageIndex'], resolve),
      children:[
        { // 取证查询
          path: '/evidenceSearch',
          name: 'evidenceSearch',
          component: resolve => require(['@/page/manage/evidenceSearch'], resolve)
        },
        { // 取证管理
          path: '/evidenceManage',
          name: 'evidenceManage',
          component: resolve => require(['@/page/manage/evidenceManage'], resolve)
        },
        { // 笔录
          path: '/evidenceRecordRead/:caseId?/:id?',
          name: 'evidenceRecordRead',
          component: resolve => require(['@/page/manage/evidenceRecord'], resolve)
        },
        { // 静态抓包
          path: '/staticAnalyse/:caseId?/:id?',
          name: 'staticAnalyse',
          component: resolve => require(['@/page/manage/staticAnalyse'], resolve)
        },
        { // 版本调整
          path: '/editVoison',
          name: 'editVoison',
          component: resolve => require(['@/page/manage/editVoison'], resolve)
        },
        { // 账号维护
          path: '/editAccount',
          name: 'editAccount',
          component: resolve => require(['@/page/manage/editAccount'], resolve)
        },
        { // APK分析
          path: '/apkAnalysis',
          name: 'apkAnalysis',
          component: resolve => require(['@/page/manage/apkAnalysis'], resolve)
        },
        { // 上报地址维护
          path: '/channelMaintenance',
          name: 'channelMaintenance',
          component: resolve => require(['@/page/manage/channelMaintenance'], resolve)
        },
        { // frontEndLog
          path: '/frontEndLog',
          name: 'frontEndLog',
          component: resolve => require(['@/page/manage/frontEndLog'], resolve)
        },
        { // 统计管理
          path: '/statisticalControl',
          name: 'statisticalControl',
          component: resolve => require(['@/page/manage/statisticalControl'], resolve)
        },
        { // 失败列表
          path: '/loseReportList',
          name: 'loseReportList',
          component: resolve => require(['@/page/manage/loseReportList'], resolve)
        },
        { // 失败列表
          path: '/loseElectronicsList',
          name: 'loseElectronicsList',
          component: resolve => require(['@/page/manage/loseElectronicsList'], resolve)
        },
        { // 消息通知
          path: '/noticeManage',
          name: 'noticeManage',
          component: resolve => require(['@/page/manage/noticeManage'], resolve)
        },
        { // 日志管理
          path: '/logManage',
          name: 'logManage',
          component: resolve => require(['@/page/manage/logManage'], resolve)
        }
      ]
    },
    {// 验证页面
      path: '/oqa',
      name: 'oqa',
      component: resolve => require(['@/page/manage/oqa'], resolve),
    },
    { // h5 上传图片
      path: '/loadImg/:id?/:title?/:isPhone?/:filesServer?',
      name: 'loadImg',
      component: resolve => require(['@/page/handH5/loadImg'], resolve),
    },
    { // h5 上传图片
      path: '/iphoneUrl/:id?',
      name: 'iphoneUrl',
      component: resolve => require(['@/page/handH5/iphoneUrl'], resolve),
    },
    {// 验证页面
      //path: '/transformPage/:u?/:p?/:c?/:v1?/:v2?',
      path: '/transformPage/:u?/:p?/:c?/:v1?/:v2?',
      name: 'transformPage',
      component: resolve => require(['@/page/new/transformPage'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js